/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ISocialsBlockViewProps } from './socials-block';
import { alignment, facebookToggle, instagramToggle, twitterToggle } from './socials-block.props.autogenerated';

const _renderFacebook = (facebookLink: string, facebookImgURL: string) : JSX.Element => {
    return (
        <a href={facebookLink}>
            <img src={facebookImgURL} alt="Facebook Logo"/>
        </a>
    );
};

const _renderInstagram = (instagramLink: string, instagramImgURL: string) : JSX.Element => {
    return (
        <a href={instagramLink}>
            <img src={instagramImgURL} alt="Instagram Logo"/>
        </a>
    );
};

const _renderTwitter = (twitterLink: string, twitterImgURL: string) : JSX.Element => {
    return (
        <a href={twitterLink}>
            <img src={twitterImgURL} alt="Twitter Logo"/>
        </a>
    );
};

export default (props: ISocialsBlockViewProps) => {
    const { linkFB, toggleFB, logoFB, linkIG, toggleIG, logoIG, linkT, toggleT, logoT, align } = props;

    let facebook;
    let instagram;
    let twitter;

    if (toggleFB === facebookToggle.on && linkFB.length && logoFB.length) {
        facebook = _renderFacebook(linkFB, logoFB);
    } else {
        facebook = <div></div>;
    }

    if (toggleIG === instagramToggle.on && linkIG.length && logoIG.length) {
        instagram = _renderInstagram(linkIG, logoIG);
    } else {
        instagram = <div></div>;
    }

    if (toggleT === twitterToggle.on && linkT.length && logoT.length) {
        twitter = _renderTwitter(linkT, logoT);
    } else {
        twitter = <div></div>;
    }

    let display;
    if (align === alignment.center) {
        display = (
            <div style={{margin: '0 auto'}}>
                {facebook}
                {instagram}
                {twitter}
            </div>
        );
    } else if (align === alignment.right) {
        display = (
            <div style={{marginLeft: 'auto', marginRight: '0'}}>
                {facebook}
                {instagram}
                {twitter}
            </div>
        );
    } else {
        display = (
            <div style={{marginLeft: '0', marginRight: 'auto'}}>
                {facebook}
                {instagram}
                {twitter}
            </div>
        );
    }

    return (
        <div className='row socials'>
            {display}
        </div>
    );
};
